export default "__VITE_ASSET__D89oNEbw__"